export default {
  title: "Código Industrial"
  , form: {
    codigo: {
      label: "Código"
      , th: "Código"
    }
    , descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5019: { text: "Ocurrió un error en el catálogo de Código Industrial" }
    , WS5019: { text: "Ocurrió un error en el catálogo de Código Industrial" }
    , JS5019: { text: "Ocurrió un error en el catálogo de Código Industrial" }
    , C55019: { text: "Ocurrió un error en el catálogo de Código Industrial" }
    , UK_CodigoIndustrial: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/codigoindustrial.js